import { Divider, Grid } from '@material-ui/core';
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Star,
} from '@material-ui/icons';
import { getStudentSkillsPro } from '@webapps/business';
import {
  Table,
  TableBody,
  TableButton,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadRow,
  TableRowExpan,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const CompetenciesPro = ({ info = {} }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const userId = info?.id;

  const { data: skillsPro = [] } = useQuery(getStudentSkillsPro, {
    key: ['softSkillsCV', userId],
    variables: { id: userId },
    enabled: typeof userId !== 'undefined',
  });

  const unique = [...new Set(skillsPro?.map((item) => item.category.label))];

  const skillsList = unique?.map((obj) => ({
    label: obj,
    skills: skillsPro?.filter(({ category }) => category.label === obj),
  }));

  const starsCounter = (value) => {
    switch (value) {
      case 1:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 2:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 3:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 4:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F3F7FF' }} />
          </>
        );
      case 5:
        return (
          <>
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
            <Star fontSize="small" style={{ color: '#F9B700' }} />
          </>
        );
    }
  };

  return (
    <div className={cx(classes.container)}>
      <div className={classes.editContainer}>
        <div className={classes.title}>
          <FormattedMessage id="business.profil.competencies.competenciesPro.title" />
        </div>
      </div>
      {!skillsList?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer style={{ padding: '20px', borderRadius: '10px' }}>
          <Table>
            <TableHead>
              <TableHeadRow style={{ color: '#FFFFFF' }}>
                {/* Ajoutez vos colonnes si nécessaire */}
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {skillsList?.map(({ id, label, skills }) => (
                <TableRowExpan key={id}>
                  {({ Row, RowData, RowHidden, expanded, toggle }) => (
                    <Row>
                      <RowData>
                        <TableCell
                          style={{
                            padding: '16px',
                            color: '#5A6DA1',
                            fontSize: '13.5px',
                            borderBottom: '1px solid #C0D9FF',
                          }}
                        >
                          {label}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            whiteSpace: 'nowrap',
                            borderBottom: '1px solid #C0D9FF',
                          }}
                        >
                          <TableButton onClick={toggle}>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </TableButton>
                        </TableCell>
                      </RowData>
                      <RowHidden>
                        <Grid container>
                          <Grid item xs={9}

                            style={{
                              color: '#152652', padding: "8px 0px 8px 8px",
                              fontSize: '13.5px',
                            }}

                          >
                            Compétences
                          </Grid>
                          <Grid item xs={3}

                            style={{ color: '#152652', padding: "8px 0px 8px 0px", fontSize: '13.5px', }}>
                            Niveau d'expérience
                          </Grid>
                        </Grid>
                        {skills?.map(({ label: skillLabel, level }) => (
                          <Grid container key={skillLabel} style={{ marginTop: '8px', padding: 8 }}>
                            <Grid item xs={9} style={{ color: '#152652', fontSize: '13.5px', }}>
                              {skillLabel}
                            </Grid>
                            <Grid item xs={3}>
                              {starsCounter(level)}
                            </Grid>
                          </Grid>
                        ))}
                      </RowHidden>
                    </Row>
                  )}
                </TableRowExpan>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      )}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    fontWeight: 600,
    color: '#152652',
    borderLeft: '3px solid #0060F9',
    fontFamily: 'Montserrat',
    lineHeight: '100%',
    paddingLeft: spacing(1),
  },
});

CompetenciesPro.propTypes = {
  info: PropTypes.object,
};

export default CompetenciesPro;
